import React, { useState } from 'react';

export const themes = {
  light: {
    name: 'light',
    background: "#E3E3E3",
    primary: "#566390",
    secondary: "#4E9FE3",
    accent:"#182AD2",
    text:"#14141C"
  },
  dark: {
    name: 'dark',
    background: "#222222",
    text: "#ffffff",
  }
}

export const ThemeContext = React.createContext(themes.light);

export const ThemeProvider = ({ children }) => {

  const [theme, setTheme] = useState(themes.dark);

  const changeTheme = (themeName) => {
    if(themeName === "light"){
      setTheme(themes.light);
    }
    if(themeName === "dark"){
      setTheme(themes.dark);
    }
  }

  return (
    <ThemeContext.Provider value={{
      theme: theme,
      changeTheme: changeTheme,
    }}>
      {children}
    </ThemeContext.Provider>
  )
}